export default __webpack_public_path__ + "28de4301e394652f59ad6f3df26279a7.png";